import { Schedule as ScheduleIcon } from "@mui/icons-material";
import { Button } from "@mui/material";

// User-facing strings
const STRINGS = {
  ADD_EVENT_TIMES: "Create",
} as const;

interface AddEventTimesButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const AddEventTimesButton = ({ onClick, disabled }: AddEventTimesButtonProps) => {
  return (
    <Button
      variant="contained"
      startIcon={<ScheduleIcon />}
      onClick={onClick}
      disabled={disabled}
      fullWidth
      sx={{
        borderRadius: "12px",
        fontWeight: "bold",
        textTransform: "none",
      }}
    >
      {STRINGS.ADD_EVENT_TIMES}
    </Button>
  );
};
